// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Config$LiveRoom from "../../Config.bs.js";

function getAllRenditions(maybeMedia) {
  return Belt_Option.mapWithDefault(maybeMedia, [], (function (media) {
                return Belt_Array.map(media.images, (function (image) {
                              return image.renditions;
                            }));
              }));
}

function getRenditions(maybeMedia, index) {
  return Belt_Option.mapWithDefault(maybeMedia, [], (function (media) {
                var image = Belt_Array.get(media.images, index);
                if (image !== undefined) {
                  return image.renditions;
                } else {
                  return [];
                }
              }));
}

function getImagesFromRecord(media, size) {
  return Belt_Array.reduce(media.images, [], (function (accumulated, image) {
                var rendition = Belt_Array.getBy(image.renditions, (function (rendition) {
                        return Caml_obj.equal(rendition.imageSize, size);
                      }));
                if (rendition !== undefined) {
                  return Belt_Array.concat(accumulated, [rendition.url]);
                } else {
                  return accumulated;
                }
              }));
}

function imageSizeToBrightspotJs(size) {
  if (typeof size === "object") {
    return "medium";
  } else if (size === "ExtraSmall") {
    return "extra_small";
  } else if (size === "Large") {
    return "large";
  } else if (size === "Small") {
    return "small";
  } else if (size === "Medium") {
    return "medium";
  } else {
    return "extra_large";
  }
}

function getBrightspotPrimaryRenditions(brightspotImagePrefixOpt, objectType, id) {
  var brightspotImagePrefix = brightspotImagePrefixOpt !== undefined ? brightspotImagePrefixOpt : Config$LiveRoom.values.brightspotImageUrl;
  var imageSizesToGet = [
    [
      "ExtraSmall",
      150
    ],
    [
      "Small",
      385
    ],
    [
      "Medium",
      800
    ],
    [
      "Large",
      1024
    ],
    [
      "ExtraLarge",
      2048
    ]
  ];
  return Belt_Array.map(imageSizesToGet, (function (param) {
                var imageSize = param[0];
                var size = imageSizeToBrightspotJs(imageSize);
                var url = "" + brightspotImagePrefix + "" + objectType + "/" + id + "/primary/" + size + "";
                return {
                        __typename: "Rendition",
                        url: url,
                        imageSize: imageSize,
                        height: 0,
                        width: param[1]
                      };
              }));
}

export {
  getAllRenditions ,
  getRenditions ,
  getImagesFromRecord ,
  imageSizeToBrightspotJs ,
  getBrightspotPrimaryRenditions ,
}
/* Config-LiveRoom Not a pure module */
